import React from "react";
import { Building, Hash, Phone, MapPin, Package } from "lucide-react";
import { FormInput, FormTextarea } from "@/components/ui";

export const StoreForm = ({ form, setForm, errors, handleInputChange }) => (
  <div className="space-y-6 animate-in fade-in slide-in-from-bottom-2 duration-300">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-6">
      <FormInput
        icon={<Building size={14} />}
        label="Store Name"
        required
        placeholder="e.g. Main Warehouse"
        field="title"
        value={form.title}
        onChange={handleInputChange}
        error={errors.title}
      />
      <FormInput
        icon={<Hash size={14} />}
        label="Store Code"
        placeholder="e.g. STR-001"
        field="code"
        value={form.code}
        onChange={handleInputChange}
        error={errors.code}
      />
      <FormInput
        icon={<Phone size={14} />}
        label="Contact Number"
        placeholder="10-digit mobile"
        field="mobile"
        value={form.mobile}
        onChange={handleInputChange}
        error={errors.mobile}
      />
      <div className="flex flex-col justify-end">
        <label className="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-1.5 opacity-80">
          Status
        </label>
        <select
          className={`input h-[44px] font-bold text-xs uppercase tracking-wider bg-slate-50/50 border-slate-200 focus:bg-white transition-all cursor-pointer ${form.active ? "text-emerald-600" : "text-slate-400"}`}
          value={form.active ? "active" : "inactive"}
          onChange={(e) =>
            setForm({ ...form, active: e.target.value === "active" })
          }
        >
          <option
            value="active"
            className="text-emerald-600 font-bold"
          >
            Active
          </option>
          <option
            value="inactive"
            className="text-slate-400 font-bold"
          >
            Inactive
          </option>
        </select>
      </div>
      <div className="lg:col-span-2">
        <FormTextarea
          icon={<MapPin size={14} />}
          label="Store Address"
          required
          placeholder="Full address of the store..."
          field="address"
          value={form.address}
          onChange={handleInputChange}
          error={errors.address}
        />
      </div>
      <div className="lg:col-span-2">
        <FormTextarea
          icon={<Package size={14} />}
          label="Description"
          placeholder="Type description..."
          field="description"
          value={form.description}
          onChange={handleInputChange}
          error={errors.description}
        />
      </div>
    </div>
  </div>
);
